/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Image, Mdx, ScrollTracking } from '@ta-interaktiv/contentbricks'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

const ADDITIONAL_SHARES = 213 + 86 + 107
const ARTICLE_ID = '10448437'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              So gefährlich ist das neue Coronavirus im Vergleich
              <div className='sub header lead'>
                Sars-CoV-2 ist ansteckender und tödlicher als eine normale
                Grippe. Aber es gibt auch deutlich schlimmere Krankheiten.
              </div>
            </div>
          </h1>
        </div>
      </header>

      <div className='ui vertical fitted segment'>
        <div className='ui text container '>
          <div className='metainfo'>
            <div className='author'>
              Yannick Wiget, Sebastian Broschinski, Marc Brupbacher
            </div>
            <div className='updated'>Aktualisiert am 25. März 2020</div>
          </div>
        </div>
      </div>
      <div className='ui vertical    segment mainGraph '>
        <div className='ui container '>
          <Image
            className='titleImage'
            file={[
              require('images/grafx_main-mobile.jpg'),
              require('images/grafx_main.jpg')
            ]}
            source='Quelle: WHO, verschiedene Studien, National Health Commission of China'
          />
        </div>
      </div>

      <div className='ui vertical  very relaxed segment'>
        <div className='ui text container '>
          <Mdx file={require('text/intro.mdx')} className='cbMDX first' />
          <Mdx className='cbMDX box' file={require('text/r0.mdx')} />
        </div>
      </div>
      <div className='ui vertical very very relaxed segment '>
        <div className='ui text container '>
          <Mdx file={require('text/p1.mdx')} />
          <ScrollTracking label='content25' />

          <Image
            file={[
              require('images/grafx_r0-ranking-mobile.jpg'),
              require('images/grafx_r0-ranking.jpg')
            ]}
            title='Ansteckungsgefahr bei Infektionskrankheiten'
            sub='R0-Wert: So viele Menschen steckt ein einzelner Erkrankter an.'
            source='Quelle: WHO, verschiedene Studien, National Health Commission of China'
          />
          <ScrollTracking label='content50' />
          <Mdx file={require('text/p2.mdx')} />
          <Image
            file={[
              require('images/grafx_mortality-ranking-mobile.jpg'),
              require('images/grafx_mortality-ranking.jpg')
            ]}
            title='Sterblichkeitsrate bei Infektionskrankheiten'
            sub='Anteil der Infizierten, die an der Krankheit sterben'
            source='Quelle: WHO, verschiedene Studien, National Health Commission of China'
          />
          <ScrollTracking label='content75' />

          <Mdx file={require('text/p3.mdx')} />
        </div>
      </div>
      {/* TODO Add your credits in this component */}
      <Footer
        additionalShares={ADDITIONAL_SHARES}
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept, Recherche und Umsetzung',
            'Yannick Wiget, Sebastian Broschinski und Marc Brupbacher'
          ]
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
      />
    </div>
  )
}
